<template>
    <div
        v-on-clickaway="closeDropdown"
        class="flex SearchBox"
        :class="{
            'SearchBox--hide-search': hideSearchBarUi,
            'SearchBox--hide-categories': hideCategoriesUi
        }"
    >
        <ais-menu-select
            v-if="filter"
            v-slot="{ items, refine }"
            attribute="categories.lvl0"
            class="relative px-4 text-blue-500 border border-blue-100 cursor-pointer SearchBox__categories"
            :class="[!searchbox ? 'w-full rounded-full' : 'w-64 rounded-full mr-2']"
            :transform-items="mergeWithDefaults"
        >
            <div
                class="flex items-center h-full"
                role="button"
                tabindex="0"
                :aria-expanded="dropdown ? 'true' : 'false'"
                :aria-label="'Filter extras by type. Active filter: ' + activeCategory"
                @click="toggleDropdown"
                @keypress.space.prevent="toggleDropdown"
            >
                <img
                    v-if="searchbox"
                    class="w-10 h-10"
                    :src="`/dist/images/geosearch/${activeCategory}.svg`"
                    alt=""
                    role="img"
                    focusable="false"
                    aria-label=""
                />

                <span class="mx-2 text-sm whitespace-no-wrap">{{ activeCategory }}</span>

                <svg
                    class="w-4 h-4 ml-auto fill-current"
                    role="img"
                    alt=""
                    focusable="false"
                    aria-label=""
                    viewBox="0 0 20 20"
                >
                    <path
                        d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                    />
                </svg>
            </div>

            <ul v-if="dropdown" class="absolute inset-x-0 z-50 w-full bg-white shadow top-full">
                <li
                    v-for="item in items"
                    :key="item.value"
                    class="px-5 py-3 font-semibold hover:bg-grey-100"
                    @click="
                        refine(item.value);
                        activeCategory = item.label;
                        trackCategory();
                        closeDropdown();
                    "
                    @keypress.space.prevent="
                        refine(item.value);
                        activeCategory = item.label;
                        closeDropdown();
                    "
                >
                    <button class="flex items-center">
                        <img
                            v-if="searchbox"
                            class="mr-2"
                            :src="`/dist/images/geosearch/${item.label}.svg`"
                            alt=""
                        />
                        {{ item.label }}
                    </button>
                </li>
            </ul>
        </ais-menu-select>

        <template v-if="searchbox">
            <form
                v-if="view == 'map'"
                class="relative flex w-full px-6 text-blue-500 border border-blue-100 rounded-full SearchBox__search-bar"
                @submit.prevent
            >
                <input
                    v-model="query"
                    type="text"
                    placeholder="Enter suburb or postcode"
                    class="w-full text-sm focus:outline-none"
                    autocomplete="off"
                    aria-label="Enter suburb or postcode - start typing, then select an option below the input field"
                    @input="searchLocations($event.target.value)"
                />
                <button aria-label="Search">
                    <svg
                        class="self-center w-4 h-4 cursor-pointer stroke-current"
                        role="img"
                        focusable="false"
                        aria-label=""
                        viewBox="0 0 18 18"
                        fill="none"
                    >
                        <circle cx="7.313" cy="7.313" r="6.563" stroke-width="1.5" />
                        <path d="M11.4 11.758l5.307 5.306" stroke-width="1.5" />
                    </svg>
                </button>

                <ul
                    v-if="filteredResults"
                    class="absolute inset-x-0 z-50 w-full bg-white shadow top-full"
                >
                    <li
                        v-for="result in filteredResults"
                        :key="result.place_id"
                        tabindex="0"
                        class="flex items-center px-6 py-3 font-semibold cursor-pointer hover:bg-grey-100"
                        @click="selectLocation(result)"
                        @keypress.space.prevent="selectLocation(result)"
                        @keypress.enter.prevent="selectLocation(result)"
                    >
                        <svg
                            class="w-4 h-4 mr-4 fill-current"
                            viewBox="0 0 20 20"
                            role="img"
                            focusable="false"
                            aria-label=""
                        >
                            <path d="M0 0l6 4 8-4 6 4v16l-6-4-8 4-6-4V0zm7 6v11l6-3V3L7 6z" />
                        </svg>

                        <div>
                            {{ result.terms[0].value }}
                            <span class="ml-2 text-sm uppercase text-grey-500">
                                {{ result.terms[1].value }}
                            </span>
                        </div>
                    </li>
                </ul>
            </form>

            <ais-search-box
                v-else-if="view == 'list'"
                :class-names="{
                    'ais-SearchBox': 'w-full flex',
                    'ais-SearchBox-form':
                        'rounded-full relative flex w-full px-6 text-blue-500 border border-blue-100',
                    'ais-SearchBox-input': 'w-full text-sm focus:outline-none'
                }"
            >
                <template v-slot:submit-icon>
                    <svg
                        class="self-center w-4 h-4 stroke-current"
                        viewBox="0 0 18 18"
                        fill="none"
                        role="img"
                        focusable="false"
                        aria-label=""
                    >
                        <circle cx="7.313" cy="7.313" r="6.563" stroke-width="1.5" />
                        <path d="M11.4 11.758l5.307 5.306" stroke-width="1.5" />
                    </svg>
                </template>

                <template v-slot:reset-icon>
                    <svg
                        class="self-center w-4 h-4 ml-2 fill-current"
                        viewBox="0 0 20 20"
                        role="img"
                        focusable="false"
                        aria-label=""
                    >
                        <path
                            d="M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"
                            fillRule="evenodd"
                        ></path>
                    </svg>
                </template>
            </ais-search-box>
        </template>
    </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import { gmapApi } from 'vue2-google-maps';

export default {
    mixins: [clickaway],

    props: {
        filter: {
            type: Boolean,
            required: true
        },

        searchbox: {
            type: Boolean,
            required: true
        },

        view: {
            type: String,
            required: true
        },

        categories: {
            type: Array,
            default() {
                return [];
            }
        },

        defaultCategory: {
            type: String,
            default: 'All Extras'
        },

        hideSearchBarUi: {
            type: Boolean,
            default: false
        },

        hideCategoriesUi: {
            type: Boolean,
            default: false
        },

        mapInfo: {
            type: Object,
            required: true
        }
    },

    data: function () {
        return {
            query: null,
            dropdown: false,
            places: null,
            autocomplete: null,
            sessionToken: null,
            results: null,
            activeCategory: this.defaultCategory
        };
    },

    computed: {
        google: gmapApi,

        // Remove country from results
        filteredResults() {
            if (!this.results) return null;
            return this.results.filter((res) => {
                return (
                    !res.types.includes('country') &&
                    !res.types.includes('administrative_area_level_1')
                );
            });
        }
    },

    watch: {
        google(api) {
            this.places = new api.maps.places.PlacesService(document.createElement('div'));
            this.autocomplete = new api.maps.places.AutocompleteService();
            this.sessionToken = new api.maps.places.AutocompleteSessionToken();
        }
    },

    methods: {
        mergeWithDefaults(items) {
            const updatedCats = [
                {
                    label: 'All Extras',
                    value: null,
                    isRefined: false
                },
                ...this.categories
            ];

            // If there's not enough results sent by the Algolia API, we lose track
            // of a potentially refined facet.
            // For example, if you refine "Apple" and then search for "chromecast",
            // "Apple" is not returned anymore and therefore we don't know that it
            // was selected based on the initial facets.
            // We need to keep track of its last state to reflect the fact that it
            // was refined in the UI.
            updatedCats.forEach((facet, index) => {
                const updatedItem = items.find((item) => item.value === facet.value);
                if (updatedItem) updatedCats[index] = updatedItem;
            });

            // If a facet cached is already returned by the Algolia API, we want it to
            // be displayed rather than to display its cached value.
            // You might need to sort the items again here because the internal
            // sorting happens before `transformItems` is called.
            // return uniqBy([...items, ...initialFacets], 'value').slice(0, brandLimit);
            return updatedCats;
        },

        searchLocations(query) {
            if (!query) {
                this.results = null;
                return;
            }

            const request = {
                input: query,
                types: ['(regions)'],
                componentRestrictions: { country: 'au' },
                location: new window.google.maps.LatLng(
                    this.mapInfo.center.lat,
                    this.mapInfo.center.lng
                ),
                radius: 100000,
                sessionToken: this.sessionToken
            };

            this.autocomplete.getPlacePredictions(request, (predictions) => {
                this.results = predictions;
            });
        },

        selectLocation(result) {
            window.dataLayer.push({
                event: 'GTM',
                event_name: 'search_extras_by_location',
                content: result.structured_formatting.main_text,
                context: null,
                location: null
            });
            // Hacky way of tracking if there are results showing after map has been updated by location change
            window.setTimeout(() => {
                if (document.querySelector('#map-no-results')) {
                    window.dataLayer.push({
                        event: 'GTM',
                        event_name: 'no_search_extras_found',
                        content: `${result.structured_formatting.main_text} | ${this.activeCategory}`,
                        context: 'filter',
                        location: null
                    });
                }
            }, 2500);

            this.results = null;

            const request = {
                placeId: result.place_id,
                fields: ['geometry', 'type'],
                sessionToken: this.sessionToken
            };

            this.places.getDetails(request, (place) => {
                this.query = result.structured_formatting.main_text;
                this.$emit('searched', place.geometry);
            });
        },

        closeDropdown() {
            this.dropdown = false;
        },

        trackCategory() {
            window.dataLayer.push({
                event: 'GTM',
                event_name: 'select_extras_search_category',
                content: this.activeCategory,
                context: null,
                location: null
            });
        },

        toggleDropdown() {
            this.dropdown = !this.dropdown;
            if (this.dropdown) {
                this.$refs.dropdownOptions.focus();
            }
        }
    }
};
</script>
<style scoped>
.SearchBox--hide-search {
    min-height: 40px;

    @screen md {
        flex-grow: 0;
    }
}
.SearchBox--hide-search .SearchBox__search-bar {
    display: none;
}
.SearchBox--hide-search .SearchBox__categories {
    border-radius: 30px;
}

.SearchBox--hide-categories .SearchBox__categories {
    display: none;
}

.SearchBox--hide-categories .SearchBox__search-bar {
    height: 48px;
    border-radius: 30px;
}
</style>
